import { Analytics } from "@shared"

import SelectFieldComponent from "./SelectField"

const SelectField = Analytics(SelectFieldComponent)

export { SelectField }
export default SelectField
